import React, { useEffect } from "react";
import {
  Form,
  FormGroup,
  Input,
  Label,
  CustomInput,
  Row,
  Col,
} from "reactstrap";
import { Multiselect } from "react-widgets";
import { compose } from "redux";
import _ from "lodash";
import Moment from "moment";

import SmileDatepicker from "components/Datepicker";
import Typeahead from "components/Typeahead";
import LoadingOverlay from "components/Indicator/LoadingOverlay";

import UserIcon from "assets/Images/av1.png";

import WithCountries from "actions/dictionary/countries";
import WithStates from "actions/dictionary/states";
import WithCities from "actions/dictionary/cities";
import WithCompanies from "actions/dictionary/companies";

import moment from "moment";

const ListItem = ({ item }) => <span>{`${item.name}`}</span>;

const General = (props) => {
  let {
    onChangePatientData,
    newPatient,
    onLoadCountries,
    countries,
    getCountries,
    onLoadStates,
    states,
    getStates,
    onLoadCities,
    cities,
    getCities,
    companies,
    onLoadCompanies,
    getCompanies,
    onChangePatientsHOC,
    panels,
  } = props;

  useEffect(() => {
    getCountries();
    if (newPatient.country !== "") {
      getStates(newPatient.country);
    }
    if (newPatient.state !== "") {
      getCities(newPatient.country, newPatient.state);
    }
    getCompanies();
  }, [
    getCities,
    getCompanies,
    getCountries,
    getStates,
    newPatient.country,
    newPatient.state,
  ]);

  return (
    <Form onSubmit={(e) => e.preventDefault()}>
      <Row>
        <Col md={8}>
          <Row>
            <Col md={12}>
              <FormGroup>
                <Label>Name</Label>
                <Input
                  type="text"
                  value={newPatient.name}
                  onChange={(e) => {
                    onChangePatientData("name", e.target.value);
                  }}
                />
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label>IC/Passport</Label>
                <Input
                  type="text"
                  value={newPatient.nric_no}
                  onChange={(e) => {
                    onChangePatientData("nric_no", e.target.value);
                  }}
                />
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label>Email</Label>
                <Input
                  type="email"
                  value={newPatient.email}
                  onChange={(e) => {
                    onChangePatientData("email", e.target.value);
                  }}
                />
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label>DOB</Label>
                <input
                  type="date"
                  className="form-control"
                  value={
                    newPatient.date_of_birth
                      ? Moment(newPatient.date_of_birth).format("YYYY-MM-DD")
                      : ""
                  }
                  onChange={(e) => {
                    let tmpAge = 0;
                    let today = moment(new Date()).get("year");
                    let DOB = moment(e.target.value).get("year");
                    tmpAge = today - DOB;
                    let tmp = _.cloneDeep(newPatient);
                    tmp["date_of_birth"] = e.target.value;
                    tmp["age"] = tmpAge;
                    onChangePatientsHOC("newPatient", tmp);
                  }}
                />
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label>Age</Label>
                <Input type="number" value={newPatient.age} disabled></Input>
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label>Gender</Label>
                <Input
                  type="select"
                  value={newPatient.gender}
                  onChange={(e) => {
                    onChangePatientData("gender", e.target.value);
                  }}
                >
                  <option></option>
                  <option value={"Male"}>Male</option>
                  <option value={"Female"}>Female</option>
                </Input>
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <CustomInput
                  id="isVaccinated"
                  type="checkbox"
                  label="Is vaccinated"
                  checked={newPatient.is_vaccinated}
                  onChange={(e) =>
                    onChangePatientData("is_vaccinated", e.target.checked)
                  }
                />
              </FormGroup>
            </Col>
            <Col md={12}>
              <FormGroup>
                <Label>Address</Label>
                <Input
                  type="text"
                  value={newPatient.address}
                  onChange={(e) => {
                    onChangePatientData("address", e.target.value);
                  }}
                />
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label>Country</Label>
                <Typeahead
                  id={"country"}
                  multiple={false}
                  options={countries}
                  onSelect={(val) => {
                    if (val && val.length > 0) {
                      onChangePatientData("country", val[0].code);
                      getStates(val[0].code);
                    } else {
                      onChangePatientData("country", "");
                    }
                  }}
                  selectedValue={
                    _.find(countries, { id: newPatient.country })
                      ? [_.find(countries, { id: newPatient.country })]
                      : []
                  }
                />
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label>Postcode</Label>
                <Input
                  type="text"
                  value={newPatient.postcode}
                  onChange={(e) => {
                    onChangePatientData("postcode", e.target.value);
                  }}
                />
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label>State</Label>
                <Input
                  type="text"
                  value={newPatient.state}
                  onChange={(e) => {
                    onChangePatientData("state", e.target.value);
                  }}
                />
                {/* <option></option>
                  {
                    states && states.map( item => {
                      return <option key={ item.code } value={ item.code }>{ item.name }</option>
                    })
                  } */}
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label>City</Label>
                <Input
                  type="text"
                  value={newPatient.city}
                  onChange={(e) => {
                    onChangePatientData("city", e.target.value);
                  }}
                />
                {/* <option></option>
                  {
                    cities && cities.map( item => {
                      return <option key={ item.code } value={ item.code }>{ item.code }</option>
                    })
                  } */}
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label>Language</Label>
                <Input
                  type="select"
                  value={newPatient.language}
                  onChange={(e) => {
                    onChangePatientData("language", e.target.value);
                  }}
                >
                  <option></option>
                  <option value={2}>Mandarin</option>
                  <option value={1}>English</option>
                  <option value={3}>Malay</option>
                </Input>
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label>
                  Contact number(Please put country code, eg for Malaysia
                  60123456789 in front of contact number for whatsapp use -
                  appointment notification)
                </Label>
                <Input
                  type="text"
                  value={newPatient.contact_number}
                  onChange={(e) => {
                    onChangePatientData("contact_number", e.target.value);
                  }}
                />
              </FormGroup>
            </Col>
          </Row>
        </Col>
        <Col md={4}>
          <img
            src={newPatient.photo === "" ? UserIcon : newPatient.photo}
            style={{ width: "60%" }}
          />
          <input type="file" accept="image/*" className="mt-2" />
          <FormGroup className="pt-3">
            <Label>Status</Label>
            <Input
              type="select"
              value={newPatient.status}
              onChange={(e) => {
                onChangePatientData("status", e.target.value);
              }}
            >
              <option value={"active"}>Active</option>
              <option value={"inactive"}>Inactive</option>
            </Input>
          </FormGroup>
          <FormGroup>
            <Label>Company/Clinic</Label>
            <Multiselect
              data={companies}
              textField={"name"}
              itemComponent={ListItem}
              onChange={(val) => {
                let tmp = [];
                val.map((item) => {
                  tmp.push(item.id);
                });
                onChangePatientData("company_ids", tmp);
              }}
            />
          </FormGroup>
          <FormGroup>
            <Label>Panel</Label>
            <Input
              type="select"
              value={newPatient.panel_id}
              onChange={(e) =>
                onChangePatientData("panel_id", parseInt(e.target.value))
              }
            >
              <option value={0}></option>
              {panels.map((item) => (
                <option value={item.id}>{item.panel_name}</option>
              ))}
            </Input>
          </FormGroup>
          <FormGroup>
            <Label>Upload file from ic reader</Label>
            <Input
              type="file"
              onChange={(e) => {
                let file = e.target.files[0];
                const reader = new FileReader();
                reader.addEventListener("load", (event) => {
                  let tmp = JSON.parse(event.target.result);
                  let tmpNewPatient = _.cloneDeep(newPatient);
                  tmpNewPatient["name"] = tmp["name"];
                  tmpNewPatient["nric_no"] = tmp["IC"];
                  tmpNewPatient["date_of_birth"] = tmp["dob"];
                  tmpNewPatient["gender"] = tmp["gender"] === "L" ? "1" : "2";
                  tmpNewPatient["address"] =
                    tmp["add1"] + " " + tmp["add2"] + " " + tmp["add3"];
                  tmpNewPatient["country"] = "MY";
                  tmpNewPatient["state"] = tmp["state"];
                  tmpNewPatient["city"] = tmp["city"];
                  tmpNewPatient["postcode"] = tmp["postcode"];
                  tmpNewPatient["status"] = "ACTIVE";
                  tmpNewPatient["photo"] =
                    "data:image/png;base64," + tmp["fullImage"];
                  props.onChangePatientsHOC("newPatient", tmpNewPatient);
                });
                reader.readAsText(file);
              }}
            />
          </FormGroup>
        </Col>
      </Row>
      {(onLoadCountries || onLoadStates || onLoadCities || onLoadCompanies) && (
        <LoadingOverlay />
      )}
    </Form>
  );
};

export default compose(
  WithCountries,
  WithStates,
  WithCities,
  WithCompanies
)(General);
